


export enum SegmentsEnum {
	head = 'Oblast hlavy',
	chest = 'Oblast krku',
	belly = 'Břicho',
	back = 'Hřbet',
	rump = 'Záď',
	tail = 'Ocas',
	upperThigh = 'Slabiny a pohlavní orgány',
	lowerThigh = 'Oblast kolene a bérce',
	hock = 'Zadní nárt',
	hindpaw = 'Zadní tlapky',
	forearm = 'Loket a předloktí',
	wrist = 'Oblast zápěstí',
	forepaw = 'Přední tlapky',
}


export const SEGMENT_ENUM_TRANSLATION_KEYS = {
	[SegmentsEnum.head]: 'surgeryInfo.segments.segmentsTypeEnum.head',
	[SegmentsEnum.chest]: 'surgeryInfo.segments.segmentsTypeEnum.chest',
	[SegmentsEnum.belly]: 'surgeryInfo.segments.segmentsTypeEnum.belly',
	[SegmentsEnum.back]: 'surgeryInfo.segments.segmentsTypeEnum.back',
	[SegmentsEnum.rump]: 'surgeryInfo.segments.segmentsTypeEnum.rump',
	[SegmentsEnum.tail]: 'surgeryInfo.segments.segmentsTypeEnum.tail',
	[SegmentsEnum.upperThigh]: 'surgeryInfo.segments.segmentsTypeEnum.upperThigh',
	[SegmentsEnum.lowerThigh]: 'surgeryInfo.segments.segmentsTypeEnum.lowerThigh',
	[SegmentsEnum.hock]: 'surgeryInfo.segments.segmentsTypeEnum.hock',
	[SegmentsEnum.hindpaw]: 'surgeryInfo.segments.segmentsTypeEnum.hindpaw',
	[SegmentsEnum.forearm]: 'surgeryInfo.segments.segmentsTypeEnum.forearm',
	[SegmentsEnum.wrist]: 'surgeryInfo.segments.segmentsTypeEnum.wrist',
	[SegmentsEnum.forepaw]: 'surgeryInfo.segments.segmentsTypeEnum.forepaw',
} as const;


export const isSegmentsEnum = (value: unknown): value is SegmentsEnum => {
	const enumValues = Object.values(SegmentsEnum);
	return typeof value === 'string' && enumValues.includes(value as SegmentsEnum);
};